/*
 * @Author: zhujiapeng
 * @Date: 2021-01-26 18:17:21
 * @LastEditors: zhujiapeng
 * @LastEditTime: 2021-01-26 18:18:48
 * @Description: 描述一下咯
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
 */

/**
   * 将秒数转为时分秒字符串
   * @param {number} t 秒数
   */
const secondToTimeStr = (t) => {
  if (t < 60) return t + '秒';
  if (t < 3600) return parseInt(t / 60) + "分" + t % 60 + '秒';
  if (3600 <= t) {
    const e = parseInt(t / 3600);
    const f = parseInt(t % 3600 / 60);
    const g = t % 60;
    let str = '';
    if (f === 0 && g === 0) {
      str = e + "小时";
    } else if (f === 0) {
      str = e + "小时" + g + '秒';
    } else if (g === 0) {
      str = e + "小时" + f + "分";
    } else {
      str = e + "小时" + f + "分" + g + '秒';
    }
    return str;
  }
}

export {
  secondToTimeStr
}